/* tslint:disable */
/* eslint-disable */
/**
 * Dataland Data Sourcing Service API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { BulkDataRequest } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
// @ts-ignore
import type { BulkDataRequestResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
// @ts-ignore
import type { ExtendedRequestHistoryEntryData } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
// @ts-ignore
import type { ExtendedStoredRequest } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
// @ts-ignore
import type { RequestHistoryEntryData } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
// @ts-ignore
import type { RequestPriority } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
// @ts-ignore
import type { RequestState } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
// @ts-ignore
import type { SingleRequest } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
// @ts-ignore
import type { SingleRequestResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
// @ts-ignore
import type { StoredRequest } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
/**
 * RequestControllerApi - axios parameter creator
 */
export const RequestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * A data request for specific frameworks and companies is being sent.
         * @summary Send a data request
         * @param {SingleRequest} singleRequest 
         * @param {string} [userId] Dataland ID of the user in whose name the request shall be made. Please omit it if you are making the request on your own behalf.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRequest: async (singleRequest: SingleRequest, userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'singleRequest' is not null or undefined
            assertParamExists('createRequest', 'singleRequest', singleRequest)
            const localVarPath = `/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(singleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the extended request history of a Request object by its unique identifier.
         * @summary Get extended request history of requests by ID
         * @param {string} dataRequestId The unique identifier of the data request on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExtendedRequestHistoryById: async (dataRequestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataRequestId' is not null or undefined
            assertParamExists('getExtendedRequestHistoryById', 'dataRequestId', dataRequestId)
            const localVarPath = `/requests/{dataRequestId}/extended-history`
                .replace(`{${"dataRequestId"}}`, encodeURIComponent(String(dataRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets all the stored data of a particular data request.
         * @summary Get all information associated with the specified data request.
         * @param {string} dataRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequest: async (dataRequestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataRequestId' is not null or undefined
            assertParamExists('getRequest', 'dataRequestId', dataRequestId)
            const localVarPath = `/requests/{dataRequestId}`
                .replace(`{${"dataRequestId"}}`, encodeURIComponent(String(dataRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the basic request history of a Request object by its unique identifier.
         * @summary Get basic request history of requests by ID
         * @param {string} dataRequestId The unique identifier of the data request on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequestHistoryById: async (dataRequestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataRequestId' is not null or undefined
            assertParamExists('getRequestHistoryById', 'dataRequestId', dataRequestId)
            const localVarPath = `/requests/{dataRequestId}/history`
                .replace(`{${"dataRequestId"}}`, encodeURIComponent(String(dataRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the priority of a data request given the data request id.
         * @summary Updates the priority of a given data request.
         * @param {string} dataRequestId The unique identifier of the data request on Dataland.
         * @param {RequestPriority} requestPriority The priority of the data request.
         * @param {string} [adminComment] A comment that can be set by Dataland admins to provide additional information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRequestPriority: async (dataRequestId: string, requestPriority: RequestPriority, adminComment?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataRequestId' is not null or undefined
            assertParamExists('patchRequestPriority', 'dataRequestId', dataRequestId)
            // verify required parameter 'requestPriority' is not null or undefined
            assertParamExists('patchRequestPriority', 'requestPriority', requestPriority)
            const localVarPath = `/requests/{dataRequestId}/priority`
                .replace(`{${"dataRequestId"}}`, encodeURIComponent(String(dataRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (requestPriority !== undefined) {
                localVarQueryParameter['requestPriority'] = requestPriority;
            }

            if (adminComment !== undefined) {
                localVarQueryParameter['adminComment'] = adminComment;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the processing state of a data request given the data request id.
         * @summary Updates the state of a given data request.
         * @param {string} dataRequestId The unique identifier of the data request on Dataland.
         * @param {RequestState} requestState The current state of the request.
         * @param {string} [adminComment] A comment that can be set by Dataland admins to provide additional information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRequestState: async (dataRequestId: string, requestState: RequestState, adminComment?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataRequestId' is not null or undefined
            assertParamExists('patchRequestState', 'dataRequestId', dataRequestId)
            // verify required parameter 'requestState' is not null or undefined
            assertParamExists('patchRequestState', 'requestState', requestState)
            const localVarPath = `/requests/{dataRequestId}/state`
                .replace(`{${"dataRequestId"}}`, encodeURIComponent(String(dataRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (requestState !== undefined) {
                localVarQueryParameter['requestState'] = requestState;
            }

            if (adminComment !== undefined) {
                localVarQueryParameter['adminComment'] = adminComment;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A bulk of data requests for specific frameworks and companies is being sent.
         * @summary Send a bulk request
         * @param {BulkDataRequest} bulkDataRequest 
         * @param {string} [userId] Dataland ID of the user in whose name the request shall be made. Please omit it if you are making the request on your own behalf.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBulkDataRequest: async (bulkDataRequest: BulkDataRequest, userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkDataRequest' is not null or undefined
            assertParamExists('postBulkDataRequest', 'bulkDataRequest', bulkDataRequest)
            const localVarPath = `/requests/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RequestControllerApi - functional programming interface
 */
export const RequestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RequestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * A data request for specific frameworks and companies is being sent.
         * @summary Send a data request
         * @param {SingleRequest} singleRequest 
         * @param {string} [userId] Dataland ID of the user in whose name the request shall be made. Please omit it if you are making the request on your own behalf.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRequest(singleRequest: SingleRequest, userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRequest(singleRequest, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequestControllerApi.createRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the extended request history of a Request object by its unique identifier.
         * @summary Get extended request history of requests by ID
         * @param {string} dataRequestId The unique identifier of the data request on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExtendedRequestHistoryById(dataRequestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExtendedRequestHistoryEntryData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExtendedRequestHistoryById(dataRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequestControllerApi.getExtendedRequestHistoryById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets all the stored data of a particular data request.
         * @summary Get all information associated with the specified data request.
         * @param {string} dataRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRequest(dataRequestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtendedStoredRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRequest(dataRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequestControllerApi.getRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the basic request history of a Request object by its unique identifier.
         * @summary Get basic request history of requests by ID
         * @param {string} dataRequestId The unique identifier of the data request on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRequestHistoryById(dataRequestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RequestHistoryEntryData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRequestHistoryById(dataRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequestControllerApi.getRequestHistoryById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the priority of a data request given the data request id.
         * @summary Updates the priority of a given data request.
         * @param {string} dataRequestId The unique identifier of the data request on Dataland.
         * @param {RequestPriority} requestPriority The priority of the data request.
         * @param {string} [adminComment] A comment that can be set by Dataland admins to provide additional information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchRequestPriority(dataRequestId: string, requestPriority: RequestPriority, adminComment?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StoredRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchRequestPriority(dataRequestId, requestPriority, adminComment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequestControllerApi.patchRequestPriority']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the processing state of a data request given the data request id.
         * @summary Updates the state of a given data request.
         * @param {string} dataRequestId The unique identifier of the data request on Dataland.
         * @param {RequestState} requestState The current state of the request.
         * @param {string} [adminComment] A comment that can be set by Dataland admins to provide additional information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchRequestState(dataRequestId: string, requestState: RequestState, adminComment?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StoredRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchRequestState(dataRequestId, requestState, adminComment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequestControllerApi.patchRequestState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A bulk of data requests for specific frameworks and companies is being sent.
         * @summary Send a bulk request
         * @param {BulkDataRequest} bulkDataRequest 
         * @param {string} [userId] Dataland ID of the user in whose name the request shall be made. Please omit it if you are making the request on your own behalf.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postBulkDataRequest(bulkDataRequest: BulkDataRequest, userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkDataRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postBulkDataRequest(bulkDataRequest, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequestControllerApi.postBulkDataRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RequestControllerApi - factory interface
 */
export const RequestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RequestControllerApiFp(configuration)
    return {
        /**
         * A data request for specific frameworks and companies is being sent.
         * @summary Send a data request
         * @param {SingleRequest} singleRequest 
         * @param {string} [userId] Dataland ID of the user in whose name the request shall be made. Please omit it if you are making the request on your own behalf.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRequest(singleRequest: SingleRequest, userId?: string, options?: RawAxiosRequestConfig): AxiosPromise<SingleRequestResponse> {
            return localVarFp.createRequest(singleRequest, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the extended request history of a Request object by its unique identifier.
         * @summary Get extended request history of requests by ID
         * @param {string} dataRequestId The unique identifier of the data request on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExtendedRequestHistoryById(dataRequestId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ExtendedRequestHistoryEntryData>> {
            return localVarFp.getExtendedRequestHistoryById(dataRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets all the stored data of a particular data request.
         * @summary Get all information associated with the specified data request.
         * @param {string} dataRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequest(dataRequestId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExtendedStoredRequest> {
            return localVarFp.getRequest(dataRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the basic request history of a Request object by its unique identifier.
         * @summary Get basic request history of requests by ID
         * @param {string} dataRequestId The unique identifier of the data request on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequestHistoryById(dataRequestId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RequestHistoryEntryData>> {
            return localVarFp.getRequestHistoryById(dataRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the priority of a data request given the data request id.
         * @summary Updates the priority of a given data request.
         * @param {string} dataRequestId The unique identifier of the data request on Dataland.
         * @param {RequestPriority} requestPriority The priority of the data request.
         * @param {string} [adminComment] A comment that can be set by Dataland admins to provide additional information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRequestPriority(dataRequestId: string, requestPriority: RequestPriority, adminComment?: string, options?: RawAxiosRequestConfig): AxiosPromise<StoredRequest> {
            return localVarFp.patchRequestPriority(dataRequestId, requestPriority, adminComment, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the processing state of a data request given the data request id.
         * @summary Updates the state of a given data request.
         * @param {string} dataRequestId The unique identifier of the data request on Dataland.
         * @param {RequestState} requestState The current state of the request.
         * @param {string} [adminComment] A comment that can be set by Dataland admins to provide additional information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRequestState(dataRequestId: string, requestState: RequestState, adminComment?: string, options?: RawAxiosRequestConfig): AxiosPromise<StoredRequest> {
            return localVarFp.patchRequestState(dataRequestId, requestState, adminComment, options).then((request) => request(axios, basePath));
        },
        /**
         * A bulk of data requests for specific frameworks and companies is being sent.
         * @summary Send a bulk request
         * @param {BulkDataRequest} bulkDataRequest 
         * @param {string} [userId] Dataland ID of the user in whose name the request shall be made. Please omit it if you are making the request on your own behalf.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBulkDataRequest(bulkDataRequest: BulkDataRequest, userId?: string, options?: RawAxiosRequestConfig): AxiosPromise<BulkDataRequestResponse> {
            return localVarFp.postBulkDataRequest(bulkDataRequest, userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RequestControllerApi - interface
 */
export interface RequestControllerApiInterface {
    /**
     * A data request for specific frameworks and companies is being sent.
     * @summary Send a data request
     * @param {SingleRequest} singleRequest 
     * @param {string} [userId] Dataland ID of the user in whose name the request shall be made. Please omit it if you are making the request on your own behalf.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRequest(singleRequest: SingleRequest, userId?: string, options?: RawAxiosRequestConfig): AxiosPromise<SingleRequestResponse>;

    /**
     * Retrieve the extended request history of a Request object by its unique identifier.
     * @summary Get extended request history of requests by ID
     * @param {string} dataRequestId The unique identifier of the data request on Dataland.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExtendedRequestHistoryById(dataRequestId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ExtendedRequestHistoryEntryData>>;

    /**
     * Gets all the stored data of a particular data request.
     * @summary Get all information associated with the specified data request.
     * @param {string} dataRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRequest(dataRequestId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExtendedStoredRequest>;

    /**
     * Retrieve the basic request history of a Request object by its unique identifier.
     * @summary Get basic request history of requests by ID
     * @param {string} dataRequestId The unique identifier of the data request on Dataland.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRequestHistoryById(dataRequestId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RequestHistoryEntryData>>;

    /**
     * Updates the priority of a data request given the data request id.
     * @summary Updates the priority of a given data request.
     * @param {string} dataRequestId The unique identifier of the data request on Dataland.
     * @param {RequestPriority} requestPriority The priority of the data request.
     * @param {string} [adminComment] A comment that can be set by Dataland admins to provide additional information.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchRequestPriority(dataRequestId: string, requestPriority: RequestPriority, adminComment?: string, options?: RawAxiosRequestConfig): AxiosPromise<StoredRequest>;

    /**
     * Updates the processing state of a data request given the data request id.
     * @summary Updates the state of a given data request.
     * @param {string} dataRequestId The unique identifier of the data request on Dataland.
     * @param {RequestState} requestState The current state of the request.
     * @param {string} [adminComment] A comment that can be set by Dataland admins to provide additional information.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchRequestState(dataRequestId: string, requestState: RequestState, adminComment?: string, options?: RawAxiosRequestConfig): AxiosPromise<StoredRequest>;

    /**
     * A bulk of data requests for specific frameworks and companies is being sent.
     * @summary Send a bulk request
     * @param {BulkDataRequest} bulkDataRequest 
     * @param {string} [userId] Dataland ID of the user in whose name the request shall be made. Please omit it if you are making the request on your own behalf.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBulkDataRequest(bulkDataRequest: BulkDataRequest, userId?: string, options?: RawAxiosRequestConfig): AxiosPromise<BulkDataRequestResponse>;

}

/**
 * RequestControllerApi - object-oriented interface
 */
export class RequestControllerApi extends BaseAPI implements RequestControllerApiInterface {
    /**
     * A data request for specific frameworks and companies is being sent.
     * @summary Send a data request
     * @param {SingleRequest} singleRequest 
     * @param {string} [userId] Dataland ID of the user in whose name the request shall be made. Please omit it if you are making the request on your own behalf.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createRequest(singleRequest: SingleRequest, userId?: string, options?: RawAxiosRequestConfig) {
        return RequestControllerApiFp(this.configuration).createRequest(singleRequest, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the extended request history of a Request object by its unique identifier.
     * @summary Get extended request history of requests by ID
     * @param {string} dataRequestId The unique identifier of the data request on Dataland.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getExtendedRequestHistoryById(dataRequestId: string, options?: RawAxiosRequestConfig) {
        return RequestControllerApiFp(this.configuration).getExtendedRequestHistoryById(dataRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets all the stored data of a particular data request.
     * @summary Get all information associated with the specified data request.
     * @param {string} dataRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRequest(dataRequestId: string, options?: RawAxiosRequestConfig) {
        return RequestControllerApiFp(this.configuration).getRequest(dataRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the basic request history of a Request object by its unique identifier.
     * @summary Get basic request history of requests by ID
     * @param {string} dataRequestId The unique identifier of the data request on Dataland.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRequestHistoryById(dataRequestId: string, options?: RawAxiosRequestConfig) {
        return RequestControllerApiFp(this.configuration).getRequestHistoryById(dataRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the priority of a data request given the data request id.
     * @summary Updates the priority of a given data request.
     * @param {string} dataRequestId The unique identifier of the data request on Dataland.
     * @param {RequestPriority} requestPriority The priority of the data request.
     * @param {string} [adminComment] A comment that can be set by Dataland admins to provide additional information.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public patchRequestPriority(dataRequestId: string, requestPriority: RequestPriority, adminComment?: string, options?: RawAxiosRequestConfig) {
        return RequestControllerApiFp(this.configuration).patchRequestPriority(dataRequestId, requestPriority, adminComment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the processing state of a data request given the data request id.
     * @summary Updates the state of a given data request.
     * @param {string} dataRequestId The unique identifier of the data request on Dataland.
     * @param {RequestState} requestState The current state of the request.
     * @param {string} [adminComment] A comment that can be set by Dataland admins to provide additional information.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public patchRequestState(dataRequestId: string, requestState: RequestState, adminComment?: string, options?: RawAxiosRequestConfig) {
        return RequestControllerApiFp(this.configuration).patchRequestState(dataRequestId, requestState, adminComment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A bulk of data requests for specific frameworks and companies is being sent.
     * @summary Send a bulk request
     * @param {BulkDataRequest} bulkDataRequest 
     * @param {string} [userId] Dataland ID of the user in whose name the request shall be made. Please omit it if you are making the request on your own behalf.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postBulkDataRequest(bulkDataRequest: BulkDataRequest, userId?: string, options?: RawAxiosRequestConfig) {
        return RequestControllerApiFp(this.configuration).postBulkDataRequest(bulkDataRequest, userId, options).then((request) => request(this.axios, this.basePath));
    }
}

